import React from "react";
import { useSnackbar } from 'notistack';
import { Button } from "reactstrap";
var CloseSnackBar = function CloseSnackBar() {
  var _useSnackbar = useSnackbar(),
    closeSnackbar = _useSnackbar.closeSnackbar;
  return /*#__PURE__*/React.createElement(Button, {
    className: "btn-sm",
    color: "light",
    onClick: function onClick() {
      return closeSnackbar();
    }
  }, "Dismiss");
};
export default CloseSnackBar;